import React from 'react';
import { DownloadIcon, PrinterIcon, Edit2Icon, AlertTriangleIcon } from 'lucide-react';
export function DepositionOutline() {
  return <div className="bg-white text-gray-900 h-full flex flex-col rounded-sm overflow-hidden border border-navy-border shadow-lg" data-id="element-41">
      <div className="bg-gray-100 border-b border-gray-300 px-4 py-3 flex justify-between items-center sticky top-0 z-10" data-id="element-42">
        <div className="flex items-center gap-3" data-id="element-43">
          <span className="font-semibold text-sm" data-id="element-44">
            Deposition Outline: John Smith (Blackstone)
          </span>
          <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded border border-blue-200" data-id="element-45">
            Draft
          </span>
        </div>
        <div className="flex gap-2" data-id="element-46">
          <button className="p-1.5 text-gray-600 hover:bg-gray-200 rounded transition-colors" title="Edit" data-id="element-47">
            <Edit2Icon size={16} data-id="element-48" />
          </button>
          <button className="p-1.5 text-gray-600 hover:bg-gray-200 rounded transition-colors" title="Print" data-id="element-49">
            <PrinterIcon size={16} data-id="element-50" />
          </button>
          <button className="p-1.5 text-gray-600 hover:bg-gray-200 rounded transition-colors" title="Export PDF" data-id="element-51">
            <DownloadIcon size={16} data-id="element-52" />
          </button>
        </div>
      </div>

      <div className="p-8 overflow-auto flex-1 font-serif text-sm leading-relaxed max-w-3xl mx-auto w-full" data-id="element-53">
        <div className="text-center mb-8" data-id="element-54">
          <h2 className="font-bold text-lg uppercase underline mb-2" data-id="element-55">
            Deposition Outline
          </h2>
          <p className="font-bold" data-id="element-56">
            Deponent: John Smith, VP of Construction, Blackstone Dev.
          </p>
          <p data-id="element-57">Case: Meridian Properties LLC v. Blackstone Development Corp.</p>
        </div>

        <div className="space-y-6" data-id="element-58">
          <section data-id="element-59">
            <h3 className="font-bold text-base mb-3" data-id="element-60">
              I. Admonitions & Background
            </h3>
            <ol className="list-decimal pl-6 space-y-2" data-id="element-61">
              <li data-id="element-62">
                Standard admonitions (under oath, verbal answers, ask for
                clarification).
              </li>
              <li data-id="element-63">Confirm current role as VP of Construction at Blackstone.</li>
              <li data-id="element-64">Establish timeline of employment.</li>
            </ol>
          </section>

          <section data-id="element-65">
            <h3 className="font-bold text-base mb-3" data-id="element-66">
              II. Contract Drafting & Review
            </h3>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-3 text-xs font-sans" data-id="element-67">
              <div className="flex items-start gap-2" data-id="element-68">
                <AlertTriangleIcon size={14} className="text-yellow-600 mt-0.5 flex-shrink-0" data-id="element-69" />
                <div data-id="element-70">
                  <span className="font-bold text-yellow-800" data-id="element-71">
                    Source Note:
                  </span>
                  <span className="text-yellow-900 ml-1" data-id="element-72">
                    In PL_ROG_1_BLK (ROG 1), Blackstone identified John Smith as
                    participating in the review of the March 15, 2022 contract.
                  </span>
                </div>
              </div>
            </div>
            <ol className="list-decimal pl-6 space-y-3" start={4} data-id="element-73">
              <li data-id="element-74">
                You reviewed the construction contract dated March 15, 2022,
                correct?
              </li>
              <li data-id="element-75">What specific sections did you review?</li>
              <li data-id="element-76">
                Did you raise any concerns about the foundation specifications
                during your review?
                <ul className="list-[lower-alpha] pl-6 mt-1 text-gray-600 italic" data-id="element-77">
                  <li data-id="element-78">Follow-up: If yes, to whom?</li>
                  <li data-id="element-79">Follow-up: Were those concerns documented?</li>
                </ul>
              </li>
            </ol>
          </section>

          <section data-id="element-80">
            <h3 className="font-bold text-base mb-3" data-id="element-81">
              III. Notice of Water Intrusion
            </h3>
            <div className="bg-blue-50 border-l-4 border-blue-400 p-3 mb-3 text-xs font-sans" data-id="element-82">
              <span className="font-bold text-blue-800" data-id="element-83">
                Contradiction Probe:
              </span>
              <span className="text-blue-900 ml-1" data-id="element-84">
                Blackstone claims first notice was Oct 12, 2023 (ROG 3).
                However, daily site logs from June 2022 (BLK_001452) mention
                "excessive pooling." Probe this gap.
              </span>
            </div>
            <ol className="list-decimal pl-6 space-y-3" start={7} data-id="element-85">
              <li data-id="element-86">
                When did you personally first become aware of water intrusion at
                the property?
              </li>
              <li data-id="element-87">
                Blackstone's interrogatory responses state the first notice was
                October 12, 2023. Do you agree with that statement?
              </li>
              <li data-id="element-88">
                <span className="font-bold" data-id="element-89">Exhibit 1:</span> Hand witness Daily
                Site Log (BLK_001452).
                <ul className="list-[lower-alpha] pl-6 mt-1" data-id="element-90">
                  <li data-id="element-91">Do you recognize this log?</li>
                  <li data-id="element-92">
                    It notes "excessive pooling" on June 15, 2022. Were you made
                    aware of this?
                  </li>
                  <li data-id="element-93">
                    Why wasn't this considered notice of a potential water
                    intrusion issue?
                  </li>
                </ul>
              </li>
            </ol>
          </section>
        </div>
      </div>
    </div>;
}